import { Text } from '@consta/uikit/Text'
import {
  applyVspProjectInWells,
  selectProjectWellVspByIds,
  useAppDispatch,
  useAppSelector,
} from '@core/core/store'
import type { ProjectId } from 'common/types'
import type { FC } from 'react'

import {
  extractFilterFormContext,
  extractWellIdContext,
  useStepController,
  useStepControllerMethods,
  VspTable,
} from '../../components'
import type { OnApplyVspFunc } from '../../types'
import css from './StepChooseVsp.css'

type StepChooseVspProps = {
  projectId: ProjectId
}

export const StepChooseVsp: FC<StepChooseVspProps> = ({ projectId }) => {
  const { activeStep } = useStepController()
  const { addNextStep, getStep } = useStepControllerMethods()
  const wellIdToApply = extractWellIdContext(getStep('wellVspSettings'))
  const form = extractFilterFormContext(getStep('chooseBaseWell'))
  const wellId = extractWellIdContext(activeStep)

  const dispatch = useAppDispatch()

  const wellsVsp = useAppSelector(state => selectProjectWellVspByIds(state, [wellId]))
  const wellVsp = wellsVsp.at(0)

  const onApplyVsp: OnApplyVspFunc =
    ({ vspId, vspName }) =>
    () => {
      if (wellIdToApply && form?.fieldId) {
        dispatch(
          applyVspProjectInWells(
            projectId,
            { vspId, wellIds: [wellIdToApply] },
            form.fieldId,
            vspName,
          ),
        )
        addNextStep(vspName, 'applyVsp', [wellIdToApply])
      }
    }

  return (
    <>
      <Text className={css.prompt} size="xs" view="secondary">
        Выберите скоростной закон
      </Text>
      <VspTable wellVsp={wellVsp} actionLabel="Применить" onApplyVsp={onApplyVsp} />
    </>
  )
}
